/* SP-PDP D – Testseite „Direkt, Preis erst am Ende“ (siehe sections/sp-pdp-mode.liquid) */
(function () {
  // Max.-Maße der Druckflächen (wie in sections/sp-logo-preview.liquid → positions.area)
  var MAX = { 'max. 30 × 15 cm': 'max. 36 × 15 cm', 'max. 30 × 40 cm': 'max. 34 × 44 cm' };

  /* ---------- Produkte mit mehr als 250 Varianten ----------
     Liquid liefert nur die ersten 250 Varianten. Fehlen dadurch Farben (z. B. Creator 2.0 mit 492 Varianten),
     hält dieses Skript den Start von sp-pdp-neu.js kurz an, lädt die Varianten der fehlenden Farben über die
     Section sp-variant-data nach, ergänzt [data-spn-data] und startet die Seite dann (max. 5 s Wartezeit). */
  /* SP-STOCK (03.10.2026): Bestand in der Matrix.
     Bestand kommt aus den Lieferanten-Syncs (Stanley/Stella, L-Shop) über variant.inventory_quantity.
     Hat das Produkt irgendwo Bestand (= Sync läuft), gilt: Variante mit Bestand 0 ist nicht lieferbar
     (Feld gesperrt, „–“). Hat das Produkt nirgends Bestand (Sync-Ausfall oder Artikel ohne Bestandsführung),
     bleibt alles bestellbar wie bisher – so sperrt ein Sync-Fehler nie einen ganzen Artikel.
     v.stock = lieferbare Menge (Zahl) oder null (nicht begrenzt). */
  var STOCK_MAP = null;
  function stockMap() {
    if (STOCK_MAP) return STOCK_MAP;
    var n = document.querySelector('[data-spn-stock]');
    try { STOCK_MAP = n ? JSON.parse(n.textContent) : {}; } catch (e) { STOCK_MAP = {}; }
    return STOCK_MAP;
  }
  function stockPrep(data) {
    var vs = data.variants || [], sm = stockMap();
    vs.forEach(function (v) {
      if (v.qty === undefined && sm[v.id]) { v.qty = sm[v.id][0]; v.track = sm[v.id][1] === 1; }
    });
    var synced = vs.some(function (v) { return v.track && v.qty > 0; });
    data.stockSync = synced;
    vs.forEach(function (v) {
      v.stock = null;
      if (!synced || !v.track) return;
      v.stock = Math.max(0, v.qty | 0);
      if (v.stock <= 0) v.available = false;
    });
  }
  /* Farben ohne eine einzige bestellbare Variante bleiben in der Farbauswahl sichtbar, aber durchgestrichen und
     nicht wählbar (03.10.2026, vorher wurden sie entfernt – dadurch passte die Farbzahl nicht zur Produktkarte).
     Sind sie wieder bestellbar, sind sie automatisch wieder wählbar. */
  function prune(el, data) {
    stockPrep(data);
    var ok = {};
    (data.variants || []).forEach(function (v) { if (v.available) ok[v.color] = 1; });
    var gone = (data.colors || []).filter(function (c) { return !ok[c.name]; }).map(function (c) { return c.name; });
    if (!gone.length || gone.length === data.colors.length) return;
    data.colors.forEach(function (c) { if (!ok[c.name]) c.soldout = true; });
    if (data.initialColor && !ok[data.initialColor]) {
      var first = data.colors.filter(function (c) { return ok[c.name]; })[0];
      data.initialColor = first ? first.name : null;
    }
    gone.forEach(function (name) {
      [].forEach.call(el.querySelectorAll('.spn-sw'), function (b) {
        if (b.getAttribute('data-spn-sw') !== name) return;
        b.disabled = true;
        b.classList.add('is-soldout');
        b.setAttribute('aria-disabled', 'true');
        b.title = name + ' – derzeit nicht lieferbar';
        b.setAttribute('aria-label', name + ', derzeit nicht lieferbar');
      });
    });
    var sw = el.querySelector('.spn-swatches');
    if (sw && !el.querySelector('.spn-sw-legend')) {
      var lg = document.createElement('p');
      lg.className = 'spn-sw-legend';
      lg.innerHTML = '<span class="spn-sw-legend__ic" aria-hidden="true"></span>Durchgestrichen = derzeit nicht lieferbar';
      sw.parentNode.insertBefore(lg, sw.nextSibling);
    }
  }
  /* SP-STOCK: Zahl unter jedem Feld (lieferbare Menge, ab 1.000 als „999“; unter 100 orange), Übermenge abfangen, Legende.
     Arbeitet auf den Zeilen, die sp-pdp-neu.js baut ([data-spn-rows]); ändert sp-pdp-neu.js selbst nicht. */
  var STOCK_MAX_SHOW = 999, STOCK_LOW = 100;
  function stockUi(el, data) {
    if (!data.stockSync || el.dataset.spnStockUi) return;
    el.dataset.spnStockUi = '1';
    var rows = el.querySelector('[data-spn-rows]');
    if (!rows) return;
    var vm = {};
    (data.variants || []).forEach(function (v) { vm[v.color + '|' + v.size] = v; });
    var legend = document.createElement('p');
    legend.className = 'spn-stocklegend'; legend.hidden = true;
    rows.parentNode.insertBefore(legend, rows);
    function cellInfo(inp) {
      var cell = inp.closest('.spn-cell'), row = inp.closest('[data-spn-row]');
      if (!cell || !row) return null;
      var name = row.getAttribute('data-spn-row'), size = cell.getAttribute('data-size');
      return { cell: cell, row: row, name: name, size: size, v: vm[name + '|' + size] };
    }
    function note(row, txt, size) {
      var n = row.querySelector('.spn-row__stocknote');
      if (!txt) { if (n && n.getAttribute('data-size') === size) n.remove(); return; }
      if (!n) { n = document.createElement('p'); n.className = 'spn-row__stocknote'; n.setAttribute('role', 'status'); row.appendChild(n); }
      n.setAttribute('data-size', size); n.textContent = txt;
    }
    function decorate() {
      var hasNum = false, hasOut = false;
      [].forEach.call(rows.querySelectorAll('.spn-qty'), function (inp) {
        var c = cellInfo(inp); if (!c) return;
        var v = c.v;
        if (inp.disabled) {
          hasOut = true; inp.title = 'Nicht lieferbar';
          inp.setAttribute('aria-label', 'Menge ' + c.name + ' ' + c.size + ', nicht lieferbar');
          return;
        }
        if (!v || typeof v.stock !== 'number') return;
        inp.setAttribute('aria-label', 'Menge ' + c.name + ' ' + c.size + ', ' + v.stock + ' lieferbar');
        if (!c.cell.querySelector('.spn-stock')) {
          var st = document.createElement('span');
          st.className = 'spn-stock' + (v.stock < STOCK_LOW ? ' is-low' : '');
          st.textContent = String(Math.min(v.stock, STOCK_MAX_SHOW)); st.setAttribute('aria-hidden', 'true');
          c.cell.appendChild(st);
        }
        hasNum = true;
        // z. B. nach „Größenmix auf alle Farben“: Menge über Bestand → auf Bestand setzen
        var n = parseInt(inp.value, 10);
        if (n > v.stock) { inp.value = String(v.stock); inp.dispatchEvent(new Event('input', { bubbles: true })); }
      });
      var lt = [];
      if (hasNum) lt.push('Zahl unter dem Feld = sofort lieferbar');
      if (hasOut) lt.push('– = nicht lieferbar');
      legend.textContent = lt.join(' · ');
      legend.hidden = !lt.length;
    }
    // läuft vor dem Eingabe-Handler von sp-pdp-neu.js (Capture-Phase) und begrenzt die Menge
    rows.addEventListener('input', function (e) {
      var inp = e.target;
      if (!inp.classList || !inp.classList.contains('spn-qty')) return;
      var c = cellInfo(inp); if (!c || !c.v || typeof c.v.stock !== 'number') return;
      var n = parseInt(String(inp.value).replace(/\D/g, ''), 10);
      if (n > c.v.stock) {
        inp.value = String(c.v.stock);
        note(c.row, c.name + ' ' + c.size + ': nur ' + c.v.stock + ' Stück sofort lieferbar. Wir haben deine ' + n + ' auf ' + c.v.stock + ' gesetzt.', c.size);
      } else {
        note(c.row, '', c.size);
      }
    }, true);
    new MutationObserver(decorate).observe(rows, { childList: true });
    decorate();
  }
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('[data-spn-root]'), node = el && el.querySelector('[data-spn-data]');
    if (!node) return;
    var tries = 0;
    (function wait() {
      var data;
      try { data = JSON.parse(node.textContent); } catch (e) { return; }
      if (el.dataset.spnReady === '1' && data && (data.variants || []).some(function (v) { return 'stock' in v; })) return stockUi(el, data);
      if (++tries < 100) setTimeout(wait, 100);
    })();
  });

  var varReady = (function () {
    var el = document.querySelector('[data-spn-root]'), node = el && el.querySelector('[data-spn-data]'), data;
    if (!node) return Promise.resolve();
    try { data = JSON.parse(node.textContent); } catch (e) { return Promise.resolve(); }
    var have = {};
    (data.variants || []).forEach(function (v) { have[v.color] = 1; });
    var miss = (data.colors || []).filter(function (c) { return !have[c.name]; }).map(function (c) { return c.name; });
    if (!miss.length) { prune(el, data); node.textContent = JSON.stringify(data); return Promise.resolve(); }
    el.dataset.spnReady = '1';
    var base = location.pathname + '?section_id=sp-variant-data';
    function get(u) {
      return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
        var n = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-spvd]');
        return n ? JSON.parse(n.textContent) : null;
      });
    }
    var work = get(base).then(function (j) {
      if (!j) return;
      var ids = {};
      j.colors.forEach(function (c) { ids[c.name] = c.id; });
      return Promise.all(miss.map(function (name) {
        if (!ids[name]) return null;
        return get(base + '&option_values=' + ids[name]).then(function (r) {
          if (!r || r.color !== name) return;
          r.variants.forEach(function (v) { data.variants.push(v); });
          if (r.image) data.colors.forEach(function (c) { if (c.name === name && !c.image) c.image = r.image; });
        }).catch(function () {});
      }));
    }).catch(function () {});
    return Promise.race([work, new Promise(function (r) { setTimeout(r, 5000); })]).then(function () {
      prune(el, data);
      node.textContent = JSON.stringify(data);
      delete el.dataset.spnReady;
      document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: 'sp-variant-data' } }));
    });
  })();

  /* ---------- Rückseite aus dem Vorderfoto nachbilden ----------
     Für Farben ohne Rückenfoto: Halsausschnitt (Innenseite + Etikett) wird mit Stoff aus der Brust gefüllt,
     oben entsteht ein flacher Rippkragen wie auf dem Rücken. Genutzt von assets/sp-logo-preview.js. */
  var backCache = {};
  window.spnMakeBack = function (url) {
    if (backCache[url]) return backCache[url];
    backCache[url] = new Promise(function (resolve) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try { resolve(buildBack(im)); } catch (e) { resolve(null); }
      };
      im.onerror = function () { resolve(null); };
      im.src = url;
    });
    return backCache[url];
  };
  function buildBack(im) {
    var W = Math.min(1000, im.naturalWidth || 1000), H = Math.round(W * im.naturalHeight / im.naturalWidth);
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.fillStyle = '#EEEEEE'; x.fillRect(0, 0, W, H);
    x.drawImage(im, 0, 0, W, H);
    var d = x.getImageData(0, 0, W, H).data, bg = [d[0], d[1], d[2]];
    function dist(k) { return Math.abs(d[k] - bg[0]) + Math.abs(d[k + 1] - bg[1]) + Math.abs(d[k + 2] - bg[2]); }
    function isS(i, j) { return dist((j * W + i) * 4) > 30; }
    // Textil-Maske (mit gefüllten Löchern je Zeile, damit das Etikett mitgefüllt wird)
    var sm = document.createElement('canvas'); sm.width = W; sm.height = H;
    var smx = sm.getContext('2d'), md = smx.createImageData(W, H), k, i, j;
    for (k = 0; k < d.length; k += 4) { md.data[k] = md.data[k + 1] = md.data[k + 2] = 255; md.data[k + 3] = Math.max(0, Math.min(255, (dist(k) - 15) * 12)); }
    for (j = 0; j < H; j++) {
      var L = -1, R = -1;
      for (i = 0; i < W; i++) if (md.data[(j * W + i) * 4 + 3] > 200) { if (L < 0) L = i; R = i; }
      if (L >= 0) for (i = L + 2; i < R - 1; i++) md.data[(j * W + i) * 4 + 3] = 255;
    }
    smx.putImageData(md, 0, 0);
    // Oberkante, Unterkante, Kragenbreite
    var cx0 = Math.round(W / 2), y0 = -1, yb = -1, span = Math.round(W * 0.05);
    for (j = 0; j < H && y0 < 0; j++) { var f = 0; for (i = cx0 - span; i < cx0 + span; i++) if (isS(i, j)) f++; if (f > span * 1.5) y0 = j; }
    for (j = H - 1; j > 0 && yb < 0; j--) if (isS(cx0, j)) yb = j;
    if (y0 < 0 || yb - y0 < H * 0.4) return null;
    var r = y0 + Math.round((yb - y0) * 0.012), l = cx0, rr = cx0;
    while (l > 0 && isS(l, r)) l--;
    while (rr < W - 1 && isS(rr, r)) rr++;
    var cx = (l + rr) / 2, a = (rr - l) / 2;
    if (a < W * 0.04 || a > W * 0.25) return null;
    var depth = a * 1.2, rib = Math.max(6, a * 0.15), curve = a * 0.16, off = Math.round((yb - y0) * 0.3);
    function layer(shape) {
      var t = document.createElement('canvas'); t.width = W; t.height = H;
      var tx = t.getContext('2d');
      tx.drawImage(c, 0, -off);
      tx.globalCompositeOperation = 'destination-in';
      var m = document.createElement('canvas'); m.width = W; m.height = H;
      shape(m.getContext('2d'));
      tx.drawImage(m, 0, 0);
      tx.drawImage(sm, 0, 0);
      return t;
    }
    // Ausschnitt mit Stoff füllen
    x.drawImage(layer(function (mx) {
      mx.filter = 'blur(' + Math.round(a * 0.07) + 'px)';
      mx.fillStyle = '#fff'; mx.beginPath(); mx.ellipse(cx, y0, a * 1.1, depth * 1.08, 0, 0, Math.PI * 2); mx.fill();
    }), 0, 0);
    // Rippkragen hinten
    var band = layer(function (mx) {
      mx.fillStyle = '#fff'; mx.beginPath();
      mx.moveTo(cx - a * 1.05, y0 - 2); mx.quadraticCurveTo(cx, y0 + curve * 2 - 2, cx + a * 1.05, y0 - 2);
      mx.lineTo(cx + a * 1.05, y0 + rib); mx.quadraticCurveTo(cx, y0 + curve * 2 + rib, cx - a * 1.05, y0 + rib);
      mx.closePath(); mx.fill();
    });
    var bx = band.getContext('2d');
    bx.globalCompositeOperation = 'source-atop'; bx.fillStyle = 'rgba(0,0,0,0.07)'; bx.fillRect(0, 0, W, H);
    x.drawImage(band, 0, 0);
    x.save(); x.strokeStyle = 'rgba(0,0,0,0.22)'; x.lineWidth = Math.max(1, W / 530); x.filter = 'blur(0.8px)';
    x.beginPath(); x.moveTo(cx - a * 0.98, y0 + rib); x.quadraticCurveTo(cx, y0 + curve * 2 + rib, cx + a * 0.98, y0 + rib); x.stroke(); x.restore();
    return new Promise(function (res) {
      c.toBlob(function (b) { res(b ? URL.createObjectURL(b) : null); }, 'image/jpeg', 0.9);
    });
  }

  function init() {
    var root = document.querySelector('.spn');
    if (!root) return;

    // Ab-Preis nur als kurzer Hinweis in der Datenzeile
    var v = root.querySelector('.spn-pbox__v'), facts = root.querySelector('.spn-facts2');
    if (v && facts && !facts.querySelector('.spn-de-from')) {
      var s = document.createElement('span');
      s.className = 'spn-de-from';
      s.textContent = v.textContent.trim().replace(/^ab\s*/i, 'ab ') + ' je Stück';
      facts.appendChild(s);
    }

    // Ablauf + Material als zugeklappte Zeilen
    [['.spn-process', '.spn-process__head'], ['.sp-mat', '.sp-mat__head']].forEach(function (p) {
      var box = root.querySelector(p[0]), head = box && box.querySelector(p[1]);
      if (!box || !head) return;
      box.classList.add('de-acc');
      head.classList.add('de-acc-head');
      head.setAttribute('role', 'button');
      head.setAttribute('tabindex', '0');
      head.setAttribute('aria-expanded', 'false');
      function tog() { var o = box.classList.toggle('is-open'); head.setAttribute('aria-expanded', o ? 'true' : 'false'); }
      head.addEventListener('click', tog);
      head.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tog(); } });
    });

    // ---------- Schritt 4: Deine Bestellung ----------
    var sum = root.querySelector('.spn-sum');
    if (sum) {
      var sh = sum.querySelector('.spn-sum__head');
      if (sh && !sh.querySelector('.spn-num')) {
        var n4 = document.createElement('span'); n4.className = 'spn-num'; n4.textContent = '4';
        sh.insertBefore(n4, sh.firstChild);
      }
      var lines = sum.querySelector('.spn-lines');
      var empty = document.createElement('p');
      empty.className = 'de-empty-note';
      empty.textContent = 'Trag in Schritt 2 deine Mengen ein, dann siehst du hier deinen Preis.';
      var unit = document.createElement('p');
      unit.className = 'de-unit';
      if (lines) { lines.parentNode.insertBefore(empty, lines); lines.parentNode.insertBefore(unit, lines.nextSibling); }

      var cents = function (t) { var m = (t || '').replace(/[^0-9,]/g, '').replace(',', '.'); return Math.round(parseFloat(m || '0') * 100); };
      var eur = function (c) { return (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; };

      var refresh = function () {
        var metaEl = sum.querySelector('[data-spn-summeta]');
        var pieces = parseInt(((metaEl && metaEl.textContent) || '0').replace(/\D.*$/, ''), 10) || 0;
        var totalEl = sum.querySelector('[data-spn-l-total]'), discEl = sum.querySelector('[data-spn-l-disclabel]');
        var total = cents(totalEl && totalEl.textContent);
        var pct = parseInt(((discEl && discEl.textContent) || '').replace(/[^0-9]/g, ''), 10) || 0;
        sum.classList.toggle('de-empty', pieces === 0);
        sum.classList.toggle('de-nodisc', pct === 0);
        unit.textContent = pieces ? 'entspricht ' + eur(Math.round(total / pieces)) + ' je Stück' : '';
      };
      // spn:change blubbert nicht – deshalb in der Capture-Phase am document mithören
      document.addEventListener('spn:change', function () { refresh(); }, true);
      root.addEventListener('input', function () { setTimeout(refresh, 0); });
      refresh(); setTimeout(refresh, 300);
    }

    // ---------- Farbkreise ohne hinterlegten Farbwert ----------
    // Viele Produkte haben an der Farb-Option keinen Farbwert, nur ein Variantenbild. Dann zeigte der Kreis
    // ein Mini-Shirt bzw. war leer. Wir lesen die Stofffarbe aus der Brustmitte des Packshots und füllen
    // damit Farbkreis, Farbpunkt in Schritt 2, Punkt über dem Foto und „In deinen Farben ansehen“.
    var picked = {};
    function sample(url) {
      return new Promise(function (res) {
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = function () {
          try {
            var c = document.createElement('canvas'), W = 60, H = Math.max(1, Math.round(60 * im.naturalHeight / im.naturalWidth));
            c.width = W; c.height = H;
            var x = c.getContext('2d', { willReadFrequently: true });
            x.drawImage(im, 0, 0, W, H);
            var d = x.getImageData(Math.round(W * 0.42), Math.round(H * 0.45), Math.max(1, Math.round(W * 0.16)), Math.max(1, Math.round(H * 0.15))).data;
            var r = [], g = [], b = [];
            for (var i = 0; i < d.length; i += 4) { r.push(d[i]); g.push(d[i + 1]); b.push(d[i + 2]); }
            var med = function (a) { a.sort(function (p, q) { return p - q; }); return a[a.length >> 1]; };
            res('rgb(' + med(r) + ',' + med(g) + ',' + med(b) + ')');
          } catch (e) { res(null); }
        };
        im.onerror = function () { res(null); };
        im.src = url;
      });
    }
    varReady.then(function () {
      var cimg = {};
      try { JSON.parse(root.querySelector('[data-spn-data]').textContent).colors.forEach(function (c) { cimg[c.name] = c.image; }); } catch (e) {}
      [].forEach.call(root.querySelectorAll('.spn-sw'), function (b) {
        var img = b.querySelector('img'), name = b.getAttribute('data-spn-sw');
        if (!name || (b.getAttribute('style') || '').indexOf('--sw') >= 0) return;
        var src = img ? (img.currentSrc || img.src) : cimg[name];
        if (!src) return;
        sample(src).then(function (rgb) {
          if (!rgb) return;
          picked[name] = rgb;
          b.style.setProperty('--sw', rgb);
          if (img) img.remove();
          decorate();
        });
      });
    });

    // Max.-Maße in Schritt 3 + Farbpunkte (Teile werden bei jeder Änderung neu gebaut)
    function paint(el, name) { if (el && name && picked[name]) { el.style.background = picked[name]; } }
    /* SP-CI-PDP (09.10.2026, Canvas Board 131 · 1A + 2B): Technik-Kacheln mit Symbol (Digitaldruck = CMYK, Stick = Nadel),
       Technik als Etikett im Logo-Kopf, einmal unter „Technik“ von Logo 1 das Hinweisfeld „Druckfreigabe per E-Mail“ (bis 10.10.2026: „Korrekturabzug“, Begriff laut Textregeln vereinheitlicht).
       sp-pdp-neu.js baut die Logo-Karten bei jeder Änderung neu – deshalb hier im MutationObserver ergänzen. */
    var FIN_IC = { druck: '<svg viewBox="0 0 24 24" aria-hidden="true" style="isolation:isolate"><circle cx="8.6" cy="9" r="5.4" fill="#00AEEF" style="mix-blend-mode:multiply"/><circle cx="15.4" cy="9" r="5.4" fill="#EC008C" style="mix-blend-mode:multiply"/><circle cx="12" cy="15" r="5.4" fill="#FFE500" style="mix-blend-mode:multiply"/></svg>', stick: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><g transform="translate(12 12) rotate(45)"><path fill="#78E6D0" fill-rule="evenodd" d="M0 11 L-1.3 3.5 L-1.3 -9 A1.3 1.3 0 0 1 1.3 -9 L1.3 3.5 Z M-0.45 -7.6 L-0.45 -4.4 A0.45 0.45 0 0 0 0.45 -4.4 L0.45 -7.6 A0.45 0.45 0 0 0 -0.45 -7.6 Z"/></g><path d="M16.3 7.9C19.6 8.6 21.2 12.4 18 14.4 15.4 16 11.6 15.6 11.4 19.6" stroke="#78E6D0" stroke-width="1.5" stroke-linecap="round"/></svg>' };
    var PROOF_IC = '<svg viewBox="0 0 24 24" fill="none" stroke="#111111" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3.5 6.5 8.5 6.5 8.5-6.5"/></svg>';
    function finOf(t) { return /stick/i.test(t || '') ? 'stick' : (/druck/i.test(t || '') ? 'druck' : ''); }
    function ciDecorate() {
      [].forEach.call(root.querySelectorAll('.spn-seg__btn'), function (b) {
        if (b.querySelector('.spn-fin-ic')) return;
        var st = b.querySelector('strong'), f = finOf(st ? st.textContent : b.textContent);
        if (!f) return;
        b.setAttribute('data-fin', f);
        var ic = document.createElement('span');
        ic.className = 'spn-fin-ic'; ic.setAttribute('aria-hidden', 'true'); ic.innerHTML = FIN_IC[f];
        b.insertBefore(ic, b.firstChild);
      });
      [].forEach.call(root.querySelectorAll('.spn-logo__title > span'), function (sp) {
        if (sp.querySelector('.spn-fin-chip')) return;
        var t = sp.textContent, k = t.lastIndexOf(' · ');
        if (k < 0) return;
        var name = t.slice(k + 3), f = finOf(name);
        if (!f) return;
        sp.textContent = t.slice(0, k) + ' ';
        var c = document.createElement('span');
        c.className = 'spn-fin-chip'; c.setAttribute('data-fin', f); c.textContent = name;
        sp.appendChild(c);
      });
      var first = root.querySelector('.spn-logo'), seg = first && first.querySelector('.spn-seg'), row = seg && seg.closest('.spn-lrow');
      if (row && !first.querySelector('.spn-proof')) {
        var p = document.createElement('div');
        p.className = 'spn-proof'; p.setAttribute('role', 'note');
        p.innerHTML = PROOF_IC + '<div><p class="spn-proof__t">Druckfreigabe per E-Mail</p><p class="spn-proof__b">Die Vorschau auf dem Foto ist eine erste Ansicht deines Logos. Vor der Produktion schicken wir dir eine digitale Vorschau mit genauer Größe und Position zur Freigabe. Erst nach deinem OK legen wir los.</p></div>';
        row.parentNode.insertBefore(p, row.nextSibling);
      }
    }
    function decorate() {
      ciDecorate();
      [].forEach.call(root.querySelectorAll('.spn-wbox .spn-hint'), function (h) {
        var t = h.textContent.trim();
        if (MAX[t]) h.textContent = MAX[t];
      });
      if (!Object.keys(picked).length) return;
      [].forEach.call(root.querySelectorAll('.spn-row__dot'), function (d) {
        var n = d.parentNode && d.parentNode.querySelector('.spn-row__name');
        paint(d, n && n.textContent.trim());
      });
      [].forEach.call(root.querySelectorAll('.splp-dot'), function (d) { paint(d, d.getAttribute('title')); });
      var sd = root.querySelector('[data-spn-stage-dot]'), sl = root.querySelector('[data-spn-stage-color]');
      paint(sd, sl && sl.textContent.trim());
    }
    decorate();
    var busy = false;
    new MutationObserver(function () {
      if (busy) return;
      busy = true;
      requestAnimationFrame(function () { decorate(); busy = false; });
    }).observe(root, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
